import styled from "styled-components";

export const Styles = styled.div`
  form {
    display: flex;
    align-items: center;

    .form-left {
      display: flex;
      align-items: center;
      border: solid #bbb 1px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      /* border-left: none; */
      padding: 4px 12px;

      input {
        border: 1px solid #bcbcbc;
        box-shadow: none;
        padding: 4px;
        border-radius: 0;
        margin-right: 20px;
        font-size: 14px;
        width: 200px;

        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }

    .group-btn {
      display: flex;
      gap: 10px;
    }

    button {
      padding: 0;
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      border-radius: 4px;
      width: 20px;
      height: 20px;
    }

    .checkbox-wrapper {
      margin-left: 10px;
    }
  }

  .header {
    display: flex;
    align-items: center;
    margin-left: 88px;
    gap: 200px;
    h3 {
      margin-bottom: 0;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .rst__rowContents,
  .rst__moveHandle {
    border-radius: 0;
    box-shadow: none;
    border-right: none;
  }

  .rst__rowLabel {
    padding-right: 10px;
  }

  .rst__moveHandle {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .rst__rowContents {
    border: none;
    padding: 0;
    /* border-top-right-radius: 4px;
    border-bottom-right-radius: 4px; */
  }

  .rst__collapseButton:hover:not(:active),
  .rst__expandButton:hover:not(:active) {
    width: 16px;
    height: 16px;
    background-size: unset;
  }

  .btn-add-node,
  .btn-remove-node {
    background-color: transparent;
  }

  .btn-add-node {
    background-color: #174a83;
  }

  .btn-remove-node {
    background-color: #ff4d4f;
  }

  .footer {
    &.group-btn {
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin-top: 30px;

      button {
        border-radius: 40px;
        border: 0;
        background-color: #174a83;
        width: 120px;
        padding: 6px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        margin-bottom: 10px;

        > svg {
          transform: rotate(135deg);
        }
      }
    }
  }

  .branch-prefecture {
    font-weight: normal !important;
    width: 200px !important;
    margin-right: 20px;
    span {
      font-size: 14px !important;
    }
    .ant-select-selector {
      display: flex;
      flex-direction: row;
      align-items: center;
      border: 1px solid #bcbcbc;
      box-shadow: none;
      padding: 4px;
      border-radius: 0;
    }
  }

  .ant-checkbox-inner {
    height: 20px;
    width: 20px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #174a83 !important;
    border-color: #174a83 !important;
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: #f5f5f5;
  }

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {
    border-color: #fff;
  }

  .ant-checkbox-inner:after {
    top: 47.5%;
    left: 28.5%;
  }
`;
